import React from 'react';

export default function StatCards({ stats }) {
  const defaultStats = {
    totalBookings: { value: 0, change: "", trend: "neutral" },
    upcomingBookings: { value: 0, subtitle: "0 today", trend: "neutral" },
    bookingsLast7: { value: 0, change: "", trend: "neutral" },
    totalDutySlips: { value: 0, change: "", trend: "neutral" },
    totalInvoices: { value: 0, change: "", trend: "neutral" },
    invoiceAmount: { value: "₹0", change: "", trend: "neutral" },
    dutySlipsWithout: { value: 0, change: "Pending", trend: "down" },
    dutySlipsWith: { value: 0, change: "0% complete", trend: "up" }
  };

  const s = {
    totalBookings: { ...defaultStats.totalBookings, ...(stats?.totalBookings || {}) },
    upcomingBookings: { ...defaultStats.upcomingBookings, ...(stats?.upcomingBookings || {}) },
    bookingsLast7: { ...defaultStats.bookingsLast7, ...(stats?.bookingsLast7 || {}) },
    totalDutySlips: { ...defaultStats.totalDutySlips, ...(stats?.totalDutySlips || {}) },
    totalInvoices: { ...defaultStats.totalInvoices, ...(stats?.totalInvoices || {}) },
    invoiceAmount: { ...defaultStats.invoiceAmount, ...(stats?.invoiceAmount || {}) },
    dutySlipsWithout: { ...defaultStats.dutySlipsWithout, ...(stats?.dutySlipsWithout || {}) },
    dutySlipsWith: { ...defaultStats.dutySlipsWith, ...(stats?.dutySlipsWith || {}) }
  };

  const getSubClass = (changeText, trend) => {
    if (!changeText) return "gray";
    const str = String(changeText).trim();
    if (trend === "down" || str.startsWith("-") || str.includes("-%") || str.toLowerCase().includes("pending")) {
      return "red-alert";
    }
    if (trend === "up" || str.startsWith("+") || str.includes("+%") || str.toLowerCase().includes("complete")) {
      return "green";
    }
    return "gray";
  };

  return (
    <div className="stat-cards-grid">
      {/* 1. Total Bookings */}
      <div className="stat-item-card">
        <span className="stat-item-title">Total Bookings — This Month</span>
        <div className="stat-item-value-row">
          <span className="stat-item-number">{s.totalBookings.value}</span>
          <span className={`stat-item-sub ${getSubClass(s.totalBookings.change, s.totalBookings.trend)}`}>
            {s.totalBookings.change}
          </span>
        </div>
      </div>

      {/* 2. Upcoming Bookings */}
      <div className="stat-item-card">
        <span className="stat-item-title">Upcoming Bookings — Next 7 Days</span>
        <div className="stat-item-value-row">
          <span className="stat-item-number">{s.upcomingBookings.value}</span>
          <span className="stat-item-sub gray">{s.upcomingBookings.subtitle}</span>
        </div>
      </div>

      {/* 3. Bookings Last 7 Days */}
      <div className="stat-item-card">
        <span className="stat-item-title">Bookings — Last 7 Days</span>
        <div className="stat-item-value-row">
          <span className="stat-item-number">{s.bookingsLast7.value}</span>
          <span className={`stat-item-sub ${getSubClass(s.bookingsLast7.change, s.bookingsLast7.trend)}`}>
            {s.bookingsLast7.change}
          </span>
        </div>
      </div>

      {/* 4. Total Duty Slips */}
      <div className="stat-item-card">
        <span className="stat-item-title">Total Duty Slips — This Month</span>
        <div className="stat-item-value-row">
          <span className="stat-item-number">{s.totalDutySlips.value}</span>
          <span className={`stat-item-sub ${getSubClass(s.totalDutySlips.change, s.totalDutySlips.trend)}`}>
            {s.totalDutySlips.change}
          </span>
        </div>
      </div>

      {/* 5. Total Invoices */}
      <div className="stat-item-card">
        <span className="stat-item-title">Total Invoices — This Month</span>
        <div className="stat-item-value-row">
          <span className="stat-item-number">{s.totalInvoices.value}</span>
          <span className="stat-item-sub gray">&nbsp;</span>
        </div>
      </div>

      {/* 6. Invoice Amount */}
      <div className="stat-item-card">
        <span className="stat-item-title">Invoice Amount — This Month</span>
        <div className="stat-item-value-row">
          <span className="stat-item-number">{s.invoiceAmount.value}</span>
          <span className={`stat-item-sub ${getSubClass(s.invoiceAmount.change, s.invoiceAmount.trend)}`}>
            {s.invoiceAmount.change}
          </span>
        </div>
      </div>

      {/* 7. Duty Slips Without Invoice */}
      <div className="stat-item-card">
        <span className="stat-item-title">Duty Slips Without Invoice</span>
        <div className="stat-item-value-row">
          <span className="stat-item-number">{s.dutySlipsWithout.value}</span>
          <div className="d-flex align-items-center gap-1">
            <span className="stat-item-sub red-alert">{s.dutySlipsWithout.change}</span>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="#dc2626" style={{ flexShrink: 0 }}>
              <circle cx="12" cy="12" r="11" fill="#dc2626" />
              <rect x="11" y="6" width="2" height="7" rx="1" fill="#ffffff" />
              <circle cx="12" cy="16.5" r="1.25" fill="#ffffff" />
            </svg>
          </div>
        </div>
      </div>

      {/* 8. Duty Slips With Invoice */}
      <div className="stat-item-card">
        <span className="stat-item-title">Duty Slips With Invoice</span>
        <div className="stat-item-value-row">
          <span className="stat-item-number">{s.dutySlipsWith.value}</span>
          <div className="d-flex align-items-center gap-1">
            <span className="stat-item-sub green">{s.dutySlipsWith.change}</span>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="#16a34a" style={{ flexShrink: 0 }}>
              <circle cx="12" cy="12" r="11" fill="#16a34a" />
              <path d="M7.5 12.5L10.5 15.5L16.5 9.5" stroke="#ffffff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}
